<div>
    <app-content-container [content_template]="page_content" [is_loading]="is_loading" [loading_text]="loading_text"
                           [custom_class]="'no-padding'"></app-content-container>
</div>
<ng-template #page_content>
    <div *ngIf="is_loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <main class="tiles padding">
        <a routerLink="/admin/games/starcitizen" class="link-clear" *ngIf="is_admin">
            <app-icon-tile title="Starcitizen" icon="fas fa-space-shuttle"></app-icon-tile>
        </a>
    </main>

</ng-template>

